import Route from '@ember/routing/route';
import { service } from '@ember/service';

import window from 'ember-window-mock';

export default class ApplicationRoute extends Route {
  @service localeManager;
  @service segment;

  async beforeModel() {
    await this.localeManager.setLocale();
  }

  activate() {
    this.segment.track('testing_tracking_with_segment', {
      browser_width: `${window.innerWidth}px`,
      browser_height: `${window.innerHeight}px`,
    });
  }
}
